
<template>
  <div>

    <!-- 검색 데이터 모달로 만들 부분  -->
    <div
      class="admin_addModalBox"
      :class="statusData.modalStatus ? '' : 'display_none'"
    >
      <div class="admin_addModalBox_dim">
      </div>
      <div class="admin_addModalBox_inner">
        <div class="admin_addModalBox_tit">
          <p>제품등록</p>
          <button
            class="admin_addModalBox_BtnClose"
            v-on:click="modal_close"
          >
          </button>
        </div>

        <div class="admin_addModalBox_search">
          <input
            type='text'
            id = 'search_data'
            name = 'search_data'
            maxLength="30"
            placeholder = "제품명을 입력해주세요."
            v-model="statusData.searchInputData"
          />
          <button
            v-on:click="product_search"
          >
            검색
          </button>
        </div>

        <div class="admin_addModalBox_result">
          <!-- 검색한 데이터가 없을 시  -->
          <div
            class="admin_addModalBox_result_noData"
            v-if="this.statusData.searchData.length === 0">
            <p>{{this.statusData.searchDataText}}</p>
          </div>

          <!-- 검색한 데이터가 있을시 시  -->
          <div
            class="admin_addModalBox_result_Data"
            v-else
            >

            <ul class="admin_addModalBox_result_Data_ulTit">
              <li>이미지</li>
              <li>브랜드</li>
              <li>제품타입</li>
              <li>제품명</li>
              <li>등록하기</li>
            </ul>

            <ul class="admin_addModalBox_result_Data_ulInfo"
              v-for="item in statusData.searchData"
              :key="item.product_ID"
              >
              <li class="admin_addModalBox_result_Data_li_img">
                <img
                  :src="statusData.baseUrlExport + item.product_image"
                  :alt="item.product_kor_name"
                  />
              </li>
              <li class="admin_addModalBox_result_Data_li_text">{{item.brand_kor_name}}</li>
              <li class="admin_addModalBox_result_Data_li_text">{{item.product_type_kor_name}}</li>
              <li class="admin_addModalBox_result_Data_li_text">{{item.product_kor_name}}</li>
              <li class="admin_addModalBox_result_Data_li_btn">
                <button
                  v-on:click="add_product(
                    item.product_ID,
                    item.product_kor_name,
                    item.product_eng_name,
                    item.product_inventory
                  )"
                >
                  등록
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div> <!-- 검색 데이터 모달로 만들 부분  -->

    <div style="display:flex">
      <AdminHeader v-bind:menu_id="'2-3'"/>
      <div class="Admin_PageBox">
        <div class="Admin_PageHeader">
          <p>메인화면 관리 - NFU PICK 관리</p>
          <div class="Admin_PageHeader_btn">
            <button class="Admin_PageHeader_btn02" v-on:click="add_colum">추가</button>
            <button class="Admin_PageHeader_btn03" v-on:click="delete_row">삭제</button>
          </div>
        </div>

        <div class="Admin_PageInner">
          <div class="Admin_PageInfo">
            <p>사용 방법 안내</p>
            <p>1. 리스트 정렬은 ID와 상관없이 순서대로이며, 상단이 우선 순위가 높습니다.</p>
            <p>2. 왼쪽 3선 작대기를 클릭&드래그하여 위/아래로 이동할 수 있습니다.</p>
          </div>
          <div ref="table"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable camelcase */
import AdminHeader from '../Section/AdminHeader.vue'
import AdminFooter from '../Section/AdminFooter.vue'
import {TabulatorFull as Tabulator} from 'tabulator-tables'
import {
  get_nfu_pick,
  get_nfu_pick_search,
  insert_nfu_pick_one,
  update_nfu_pick,
  update_nfu_pick_status,
  update_nfu_pick_order,
  delete_nfu_pick,
  base_url_export
} from '../../ETC/Axios.vue'
import {
  getTodayDate
} from '../../ETC/Validation.vue'
import { ref } from 'vue'

export default {
  name: 'AdminNfuPickManagement',
  components: {
    AdminHeader: AdminHeader,
    AdminFooter: AdminFooter
  },
  data () {
    return {
      tabulator: null,
      statusData: ref({
        modalStatus: false,
        searchData: [],
        searchInputData: '',
        searchDataText: '제품을 검색해주세요.',
        clickNfuPickID: 0,
        baseUrlExport: base_url_export
      })
    }
  },
  methods: {
    add_colum: function () {
      insert_nfu_pick_one().then((result) => {
        this.tabulator.addRow({
          id: result[0].nfu_pick_ID,
          product_ID_use_nfu_pick: 0,
          nfu_pick_ID: result[0].nfu_pick_ID,
          product_kor_name: '',
          product_eng_name: '',
          product_inventory: 0,
          nfu_pick_status: '미사용',
          nfu_pick_registe: getTodayDate()
        }, true)
      })
    },
    delete_row: function () {
      let temp_delete_array = []
      this.tabulator.getSelectedData().forEach((element) => {
        temp_delete_array.push(element.nfu_pick_ID)
      })
      delete_nfu_pick(temp_delete_array).then((result) => {
        if (result === undefined) {
          alert('삭제가 되지 않았습니다. 관리자한테 확인해주세요.')
        } else {
          alert('삭제가 완료 되었습니다.')
          window.location.reload()
        }
      })
    },
    detail_icon: function () {
      return `
      <b>제품변경하기</b>
      `
    },
    cell_click: function (e, cell) {
      this.statusData.modalStatus = true
      this.statusData.clickNfuPickID = cell.getRow().getData().nfu_pick_ID
    },
    cell_edited: function (cell) {
      if (cell._cell.column.field === 'nfu_pick_status') {
        const nfu_pick_status_array = ['', '사용', '미사용']
        const nfu_pick_ID = cell.getData().nfu_pick_ID
        const nfu_pick_status = cell._cell.value
        const product_ID_use_nfu_pick = cell.getData().product_ID_use_nfu_pick
        if (product_ID_use_nfu_pick === 0) {
          alert('제품 지정 후 사용 여부를 변경할 수 있습니다.')
          this.tabulator.updateData([{
            id: nfu_pick_ID,
            nfu_pick_status: cell._cell.oldValue
          }])
        } else if (nfu_pick_status !== '') {
          update_nfu_pick_status(
            nfu_pick_ID,
            nfu_pick_status
          ).then(result => {
            this.tabulator.updateData([{
              id: nfu_pick_ID,
              nfu_pick_status: nfu_pick_status_array[nfu_pick_status]
            }])
          })
        } else {
          this.tabulator.updateData([{
            id: nfu_pick_ID,
            nfu_pick_status: cell._cell.oldValue
          }])
        }
      }
    },
    modal_close: function () {
      this.statusData.modalStatus = false
    },
    product_search: function () {
      if (this.statusData.searchInputData.length < 3) {
        alert('최소 3자이상 입력해주세요.')
      } else {
        get_nfu_pick_search(this.statusData.searchInputData).then(result => {
          if (result.length === 0) {
            this.statusData.searchData = []
            this.statusData.searchDataText = '검색에 맞는 제품이 없습니다.'
          } else {
            this.statusData.searchData = result
          }
        })
      }
    },
    add_product: function (
      product_ID,
      product_kor_name,
      product_eng_name,
      product_inventory
    ) {
      update_nfu_pick(
        this.statusData.clickNfuPickID,
        product_ID
      ).then(result => {
        this.tabulator.updateData([{
          id: this.statusData.clickNfuPickID,
          product_ID_use_nfu_pick: product_ID,
          nfu_pick_ID: this.statusData.clickNfuPickID,
          product_kor_name: product_kor_name,
          product_eng_name: product_eng_name,
          product_inventory: product_inventory
        }])
        this.statusData.modalStatus = false
      })
    }
  },
  mounted () {
    get_nfu_pick().then(result_data => {
      this.tabulator = new Tabulator(this.$refs.table, {
        data: result_data,
        layout: 'fitData',
        movableRows: true,
        columns: [
          {rowHandle: true, formatter: 'handle', headerSort: false, frozen: true, width: 30, minWidth: 30},
          {formatter: 'rowSelection',
            titleFormatter: 'rowSelection',
            headerSort: false,
            cellClick: function (e, cell) {
              cell.getRow().toggleSelect()
            }
          },
          {title: 'id', field: 'id', headerSort: false, visible: false},
          {title: '제품ID', field: 'product_ID_use_nfu_pick', headerSort: false, visible: false},
          {title: 'ID', field: 'nfu_pick_ID', headerSort: false},
          {title: '제품등록(클릭)',
            formatter: this.detail_icon,
            hozAlign: 'center',
            headerSort: false,
            cellClick: this.cell_click
          },
          {title: '한글명', field: 'product_kor_name', headerSort: false},
          {title: '영문명', field: 'product_eng_name', headerSort: false},
          {
            title: '재고수량',
            field: 'product_inventory',
            headerSort: false,
            formatter: 'money',
            formatterParams: {
              decimal: ',',
              thousand: ',',
              symbol: '개',
              symbolAfter: 'p',
              negativeSign: true,
              precision: false
            }
          },
          {
            title: '사용 여부(클릭)',
            field: 'nfu_pick_status',
            headerSort: false,
            editor: 'list',
            cellEdited: this.cell_edited,
            editorParams: {
              values: {
                '1': '사용',
                '2': '미사용'
              }
            }
          },
          {title: '등록 일자', field: 'nfu_pick_registe', headerSort: false},
          {title: '수정 일자', field: 'nfu_pick_modified', headerSort: false}
        ]
      })
      this.tabulator.on('rowMoved', function (row) {
        let temp_nfu_pick_order_array = []
        let nfu_pick_order = 0
        const table = row.getTable()
        table.getRows().forEach(element => {
          temp_nfu_pick_order_array.push({
            nfu_pick_order: nfu_pick_order,
            nfu_pick_ID: element._row.data.nfu_pick_ID
          })
          nfu_pick_order++
        })
        update_nfu_pick_order(temp_nfu_pick_order_array).then(result => {
          if (result === undefined) {
            alert('순서가 변경되지 않았습니다. 관리자한테 확인해주세요.')
          }
        })
      })
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/MainManagement/AdminNfuPickManagement.vue